import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/page-header";
import { GrafanaEmbedFrame } from "@/components/grafana-embed";
import { Skeleton } from "@/components/ui/skeleton";
import { api } from "@/lib/api";
import { GRAFANA_EMBED_QUERY_OPTIONS } from "@/lib/grafana-embed-query";
import { RETENTION_HELP } from "@/lib/dashboard-time";

export function CompliancePage(): JSX.Element {
  const embedQuery = useQuery({
    queryKey: ["grafana-embed", "feeder-compliance"],
    queryFn: () => api.grafanaComplianceEmbed(),
    ...GRAFANA_EMBED_QUERY_OPTIONS,
  });

  return (
    <>
      <PageHeader title="Feeder Compliance" description="Service-band observations for the current tenant scope." />
      <p className="mb-4 text-xs text-muted-foreground">{RETENTION_HELP}</p>
      {embedQuery.error ? <ErrorBanner error={embedQuery.error} /> : null}
      {!embedQuery.error && !embedQuery.isFetchedAfterMount ? (
        <Skeleton className="h-[calc(100vh-12rem)] min-h-[720px] w-full" />
      ) : !embedQuery.error && embedQuery.isFetchedAfterMount && embedQuery.data ? (
        <GrafanaEmbedFrame
          url={embedQuery.data.url}
          title="Feeder Compliance dashboard"
          onRetry={() => void embedQuery.refetch()}
        />
      ) : null}
    </>
  );
}

function ErrorBanner({ error }: { error: unknown }): JSX.Element {
  return (
    <div className="mb-6 rounded-md border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive">
      {error instanceof Error ? error.message : "Failed to load the compliance dashboard"}
    </div>
  );
}
